import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IRPATRIMONIAL } from '../../../../app.constants';
import { DataAcaoJudicialModel } from '../../../shared/models/data-acao-judicial.model';
import { IrFracaoPatrimonialObeterAnosModel } from '../../../shared/models/ir-fracao-patrimonial-obter-anos.model';
import { IrSubJudiModel } from '../../../shared/models/ir-sub-judi.model';

@Injectable()
export class IrFracaoPatrimonialService {


    constructor(private httpClient: HttpClient) { }



    getConsultaAcao(cdCentrus: number) {
      return this.httpClient
        .get<DataAcaoJudicialModel>(`${IRPATRIMONIAL}/dataAcaoJudicial/${cdCentrus}`)
        .toPromise();
    }

    getObterTotAno(cdCentrus: number) {
      return this.httpClient
        .get<Array<IrFracaoPatrimonialObeterAnosModel>>(`${IRPATRIMONIAL}/obterAnos/${cdCentrus}`)
        .toPromise();
    }

    getObterIrSubJudice(cdCentrus: number, ano: number) {
      return this.httpClient
        .get<Array<IrSubJudiModel>>(`${IRPATRIMONIAL}/obterIrSubJudice/${cdCentrus}/${ano}`)
        .toPromise();
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/ir-fracao-patrimonial/service/ir-fracao-patrimonial.service.ts